var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"skeletons-TextSkeleton bg-skeleton",class:_vm.pulseClasses,attrs:{"aria-hidden":"true","data-test":"container"}},[_c('span',{staticClass:"whitespace-nowrap",attrs:{"data-test":"characters"},domProps:{"innerHTML":_vm._s(_vm.spaceChars)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }